<script>
export default {
    methods: {
        // Función para cambiar la acción del PDV
        changePDVActionTo(action) {
            // BS-6206: los tabs "Mi carta" y "Administración de Stock" son secciones de la
            // misma ruta, así que este cambio no navega y el beforeRouteLeave de la página no
            // dispara. Si la carta tiene cambios sin guardar, se deja el pedido pendiente y la
            // página lo confirma con el mismo modal que usa para la navegación.
            if (action !== this.$store.getProductActionSelected
                && this.$pdv.getMenuHasUnsavedChanges) {
                this.$pdv.setPendingTabAction(action);
                return;
            }
            this.$store.setProductActionSelected(action);
        }
    },
    computed: {
        // Tabs disponibles para el PDV
        getTabsPDV() {
            return [
                {
                    id: 1,
                    title: "Mi carta",
                    param: "productManagementPDV",
                    show: true,
                    canBeHide: true,
                },
                {
                    id: 2,
                    title: "Administración de Stock",
                    param: "stockManagementPDV",
                    show: this.$store.getIsStockEnabled, 
                    canBeHide: true,
                },
            ];
        },
        
        // Tab actualmente seleccionado en el PDV
        pdvTabSelected() {
            let tabSelected = this.$store.getProductActionSelected || 'productManagementPDV';
            return this.getTabsPDV.filter((x) => x.param === tabSelected)[0] || this.getTabsPDV[0];
        }
    }
}
</script>
